<template>
  <div>
    <div class="view-area">
      <div class="info-area">
        <div class="brand-images">
          <img
            v-for="(brand, index) in brands"
            :key="brand.name"
            class="brand-image"
            :src="generateImage(`${brand.name}_logo_img.png`)"
            @click="openModal(index)"
          >
        </div>
        <p class="title pc">BRAND LIST</p>
      </div>
    </div>
    <Menu class="menu"/>
    <transition name="fade">
      <BrandModal
        v-show="isShowModal"
        :brand="brands[selectedIndex]"
        :currentIndex="selectedIndex"
        :maxIndex="brands.length - 1"
        @close="closeModal"
        @change="changeBrand"
      />
    </transition>
  </div>
</template>

<script>
import Footer from './modules/Footer'
import Menu from './modules/Menu'
import BrandModal from './modules/BrandModal'

export default {
  name: 'BrandList',
  components: {
    Footer,
    Menu,
    BrandModal
  },
  data () {
    return {
      isShowModal: false,
      selectedIndex: 0,
      brands: [
        {
          name: 'louren',
          url: 'https://louren.jp',
          description: '理想とする女性の名は ”louren”<br>その時の気分や流行からインスパイヤされた<br>彼女のライフスタイルを詰め込んだ<br>リアルクローゼットを再現<br>媚びてないのにどこか色っぽい<br>全ての女性に隠れた魅力を引き出す服<br>飾らない女性らしさと<br>心地よいライフスタイルを提案した<br>大人のフレンチベーシックスタイル',
          designerName: 'SUZUMI SATO',
          title: 'Director / Designer',
          born: '1994年12月24日 東京生まれ',
          profile: 'デザイン工学部システムデザイン学科を卒業後WEBデザイナーとして就職。<br>2018年秋 アパレルブランド「louren」を始動。<br>ブランド全体のクリエイティブディレクター兼デザイナー。'
        },
        {
          name: 'hella',
          url: 'https://hella-design.com',
          description: 'ナチュラルで繊細<br>どこか目を惹くベーシックアイテムをラインナップ<br>カジュアルでありながどこか女性らしさを取り入れた<br>ハンサムレディスタイルをご提案<br>ヴィンテージライクと現代のアーバンスタイルを<br>融合した新たな大人レディースブランド',
          designerName: 'SATSUKI ITO',
          title: 'Director / Designer',
          born: '1994年10月16日 東京都生まれ',
          profile: '福岡の美容専門学校を卒業後上京。アイデザイナーとして就職。 <br>2020年秋 アパレルブランド 「Hella」を始動。<br>ブランド全体のクリエイティブディレクター兼デザイナー。'
        }
      ]
    }
  },
  methods: {
    generateImage (file) {
      return require(`@/assets/${file}`)
    },
    openModal (index) {
      this.selectedIndex = index
      this.isShowModal = true
    },
    closeModal () {
      this.isShowModal = false
    },
    changeBrand (index) {
      this.selectedIndex = index
    }
  }
}
</script>

<style scoped>
.view-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
@supports (-webkit-touch-callout: none) {
  .view-area {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.info-area {
  width: 50%;
}
.brand-images{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}
.brand-image {
  width: 50%;
  box-sizing: border-box;
  cursor: pointer;
}

.title {
  font-size: 11px;
  margin-top: 60px;
  text-align: center;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
@media(max-width: 1000px) {
  .info-area{
    width: 500px;
  }
}
@media(max-width: 800px) {
  .info-area{
    width: 450px;
  }
}
@media(max-width: 700px) {
  .info-area{
    width: 400px;
  }
}

@media(min-width:640px) {
  .brand-image:nth-of-type(-n+2){
    margin-bottom: 20px;
  }
  .brand-image:nth-of-type(odd){
    padding-right: 10px;
  }
  .brand-image:nth-of-type(even){
    padding-left: 10px;
  }
}

@media (max-width: 639px) {
  .menu {
    background-color: rgb(244, 244, 244);
  }
  .title {
    margin-top: 20px;
  }
  .view-area {
    padding-top: 54px;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .view-area::-webkit-scrollbar {
    display: none;
  }
  .info-area {
    width: 100%;
    padding: 0px 32px;
    margin: 54px 0px 32px;
  }
  .brand-images {
    flex-direction: column;
  }

  .brand-image {
    width: 100%;
    margin-bottom: 32px;
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BrandList.vue